var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86377 17.5184C9.48429 17.8737 8.97708 18.0723 8.44922 18.0723C7.92136 18.0723 7.41415 17.8737 7.03467 17.5184C3.55964 14.245 -1.09734 10.5883 1.17373 5.27947C2.40167 2.40903 5.34929 0.572266 8.44922 0.572266C11.5491 0.572266 14.4968 2.40903 15.7247 5.27947C17.9929 10.5816 13.3474 14.2563 9.86377 17.5184Z",
    stroke: "#C4AA6F",
    strokeWidth: 1.14545
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5107 8.44727C11.5107 10.1386 10.1396 11.5098 8.44824 11.5098C6.75687 11.5098 5.38574 10.1386 5.38574 8.44727C5.38574 6.75589 6.75687 5.38477 8.44824 5.38477C10.1396 5.38477 11.5107 6.75589 11.5107 8.44727Z",
    stroke: "#C4AA6F",
    strokeWidth: 1.14545
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8196158a7f4a7a584554bf187eba3ab1.svg";
export { ForwardRef as ReactComponent };